import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DiaryActionChip } from '@/components/DiaryHeader/DiaryActionChip';
import { ClockFilled } from '@/components/Icons/ClockFilled';
import { LessonTimesModal } from '@/components/LessonTimesModal';

interface Props {
  className?: string;
}

export const LessonTimesChip: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <DiaryActionChip
        className={className}
        label={t('diary.timetable')}
        icon={<ClockFilled className="size-4" />}
        onClick={() => setIsModalOpen(true)}
      />

      {isModalOpen && (
        <LessonTimesModal isOpen onClose={() => setIsModalOpen(false)} />
      )}
    </>
  );
};
